module.exports = __webpack_public_path__ + "img/banner05_info_S_1.b97865ee.png";